import React, { memo } from "react";

import { Box, Card, Heading, Stack, Text } from "@origin-digital/ods-core";

import { IconHouse } from "@/components/icons";
import {
  BillFrequencyEnum,
  IIRecommendationResponse,
  IISystemSizeMinMaxResponse,
} from "@/contract/generated/electrify-v1";
import { formatLabel, formatNumberWithCommas } from "@/utils";

import { solarOutlook as content } from "../content.json";

type PropertyProps = {
  solarOutlook: IIRecommendationResponse;
  recommendationSystem: IISystemSizeMinMaxResponse;
};

export const Property = memo(
  ({ solarOutlook, recommendationSystem }: PropertyProps) => {
    const { label, testId } = content;
    const { suburb, state } = solarOutlook;
    const { billSavingPeriod = BillFrequencyEnum["MONTHLY"], billAmount } =
      recommendationSystem;

    return (
      <Box display="flex" height="full" data-id={testId.property}>
        <Stack space="medium">
          <Heading variant="h4" weight="bold">
            {label.yourProperty}
          </Heading>
          <Card
            backgroundColor="grey50"
            paddingXSpecific="none"
            paddingYSpecific="none"
          >
            <Box
              paddingTop={{ xs: "medium" }}
              paddingBottom={{ xs: "medium", lg: "large" }}
              paddingX={{
                xs: "medium",
                sm: "xlarge",
                lg: "large",
              }}
            >
              <Box display="flex" flexDirection={{ xs: "row", lg: "column" }}>
                <IconHouse />
                <Box
                  marginTop={{ xs: "none", lg: "small" }}
                  marginLeft={{ xs: "medium", lg: "none" }}
                  alignSelf="center"
                >
                  <Text tone="neutralDark">
                    {formatLabel(
                      label.basedOn,
                      (value) => (
                        <b>{value}</b>
                      ),
                      `${suburb}, ${state}`,
                      billSavingPeriod.toLowerCase(),
                      `$${formatNumberWithCommas(billAmount)}`
                    )}
                  </Text>
                </Box>
              </Box>
            </Box>
          </Card>
        </Stack>
      </Box>
    );
  }
);
